import React, { useState, useEffect } from "react";
import {
  Box,
  Tabs,
  Tab,
  Typography,
  Divider,
  Stack,
  TextField,
  InputAdornment,
  Button,
  Alert,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { getGeneralPercentage, saveGeneralPercentage } from "../api/settings";

function TabPanel({ children, value, index }) {
  return (
    <div hidden={value !== index}>
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  );
}

const AllgemeineEinstellungen = () => {
  const [percentage, setPercentage] = useState(""); // Initialize as empty string for controlled input
  const [alert, setAlert] = useState(null);

  // Fetch percentage on mount
  useEffect(() => {
    const fetchPercentage = async () => {
      try {
        const value = await getGeneralPercentage();
        setPercentage(value.toString()); // Convert to string for TextField
      } catch (error) {
        console.error("Failed to load percentage:", error.message);
        setAlert({ severity: "error", message: "Fehler beim Laden des Prozentsatzes!" });
      }
    };
    fetchPercentage();
  }, []);

  // Handle input change
  const handlePercentageChange = (e) => {
    const value = e.target.value;
    // Allow only numbers and empty string
    if (/^\d*$/.test(value)) {
      setPercentage(value);
    }
  };

  // Handle save
  const handleSave = async () => {
    const numPercentage = Number(percentage);
    if (isNaN(numPercentage)) {
      setAlert({ severity: "error", message: "Bitte geben Sie einen gültigen Prozentsatz ein!" });
      return;
    }

    try {
      await saveGeneralPercentage(numPercentage);
      setAlert({ severity: "success", message: "Änderungen erfolgreich gespeichert!" });
    } catch (error) {
      console.error("Failed to save percentage:", error.message);
      setAlert({ severity: "error", message: "Fehler beim Speichern der Änderungen!" });
    }
  };

  return (
    <>
      {alert && (
        <Stack sx={{ mb: 3 }}>
          <Alert icon={<CheckIcon fontSize="inherit" />} severity={alert.severity}>
            {alert.message}
          </Alert>
        </Stack>
      )}
      <Stack>
        <Typography variant="h6">Allgemeiner Prozentsatz</Typography>
        <Typography sx={{ color: "text.secondary", mb: 1 }}>
          Ändere diesen Anteil, um die Tagesabrechnung nach Schichtende abzustimmen.
        </Typography>
        <Divider sx={{ pt: 1, pb: 1 }} />
        <Stack
          direction="row"
          spacing={8}
          sx={{ mt: 2, mb: 1 }}
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography sx={{ fontWeight: 600 }}>Prozentsatz</Typography>
          <TextField
            id="outlined-basic"
            variant="outlined"
            size="small"
            sx={{ width: "100%" }}
            value={percentage}
            onChange={handlePercentageChange}
            inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
            slotProps={{
              input: {
                startAdornment: <InputAdornment position="start">%</InputAdornment>,
              },
            }}
          />
        </Stack>
      </Stack>
      <Divider sx={{ pt: 1, pb: 1 }} />
      <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3, gap: 2 }}>
        <Button color="primary" variant="outlined">Abbrechen</Button>
        <Button color="secondary" variant="outlined" onClick={handleSave}>
          Änderungen speichern
        </Button>
      </Box>
    </>
  );
};

export default function Settings() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
        Einstellungen
      </Typography>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={value} onChange={handleChange} aria-label="Einstellungen Tabs">
          <Tab label="Allgemeine" />
          <Tab label="Profil" disabled />
          <Tab label="Datenbank" disabled />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <AllgemeineEinstellungen />
      </TabPanel>
      <TabPanel value={value} index={1}>
        Profil
      </TabPanel>
      <TabPanel value={value} index={2}>
        Datenbank
      </TabPanel>
    </Box>
  );
}